import { useState, useEffect } from 'react';
import { Facebook, Twitter, Linkedin, Youtube, Instagram } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import logo from '../img/logo.svg'
import './Footer.css';
import visa_logo from '../img/payment/visa.svg'
import mastercard_logo from '../img/payment/mastercard.svg'

/**
 * Компонент Footer - переиспользуемый подвал сайта
 */
const Footer = () => {
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = useState('desktop');

  // Отслеживание размера экрана
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setScreenSize('mobile');
      } else if (width < 968) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const isMobile = screenSize === 'mobile';

  // Данные для социальных сетей
  const socialLinks = [
    { name: 'Facebook', icon: Facebook, url: '#' },
    { name: 'Twitter', icon: Twitter, url: '#' },
    { name: 'LinkedIn', icon: Linkedin, url: '#' },
    { name: 'YouTube', icon: Youtube, url: '#' },
    { name: 'Instagram', icon: Instagram, url: '#' }
  ];

  // Данные для платежных систем
  const paymentSystems = [
    { name: 'Visa', src: visa_logo },
    { name: 'Mastercard', src: mastercard_logo }
  ];

  return (
    <footer id="footer" className="footer">
      <div className="footer-top">
        <div className="footer-column">
          <div className="footer-logo-container">
            <img
              src={logo}
              alt="Логотип Debt Agent"
              className="footer-logo-image"
            />
            <div className="footer-logo-text">
              <span className="footer-logo-title">DEBT AGENT</span>
              <span className="footer-logo-subtitle">protecting your debts since 2001</span>
            </div>
          </div>
          <p className="footer-description">
            We help people achieve financial freedom by providing 100% free legal services 
            to manage and eliminate debt. Your trusted partner since 2001.
          </p>
          <div className="social-icons-container">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a key={social.name} href={social.url} className="social-icon" aria-label={social.name}>
                  <Icon size={isMobile ? 18 : 20} color="#ffffff" />
                </a>
              );
            })}
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-column-title">Contact Us</h3>
          <ul className="footer-list">
            <li><a href="mailto:support@debtagent.com" className="footer-link">support@debtagent.com</a></li>
            <li><a href="tel:+18001234567" className="footer-link">+1 (800) 123-4567</a></li>
            <li><span className="footer-link">123 Financial Street, Suite 100<br />New York, NY 10001</span></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-column-title">Quick Links</h3>
          <ul className="footer-list">
            <li><button onClick={() => navigate('/', { state: { scrollTo: 'hero' } })} className="footer-link-button">Home</button></li>
            <li><button onClick={() => navigate('/', { state: { scrollTo: 'testimonial' } })} className="footer-link-button">About Us</button></li>
            <li><button onClick={() => navigate('/', { state: { scrollTo: 'legal-help' } })} className="footer-link-button">Our Services</button></li>
            <li><button onClick={() => navigate('/', { state: { scrollTo: 'success-stories' } })} className="footer-link-button">Success Stories</button></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-column-title">Resources</h3>
          <ul className="footer-list">
            <li><a href="#blog" className="footer-link">Blog</a></li>
            <li><button onClick={() => navigate('/privacy-policy')} className="footer-link-button">Privacy Policy</button></li>
            <li><button onClick={() => navigate('/terms-of-service')} className="footer-link-button">Terms of Service</button></li>
            <li><a href="#contact" className="footer-link">Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">© 2025 Debt Agent. All rights reserved.</p>
        <div className="payment-icons-container">
          {paymentSystems.map((payment) => (
            <img
              key={payment.name}
              src={payment.src}
              alt={`${payment.name} logo`}
              className="payment-icon"
            />
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
